/**
 * PRO Fall Convention launch details.
 *
 * The handoff calls these out in three places (announcement bar, Home
 * partnership card, About timeline) and requires them to stay in sync, so they
 * live here as the single source rather than being retyped per section. Move
 * this to config/CMS when the marketing copy becomes editable.
 */
export const marketingEvent = {
  name: 'PRO Fall Convention & Trade Show 2026',
  datesLabel: 'September 13–16, 2026',
  datesShort: 'Sept 13–16, 2026',
  venue: 'Talking Stick Resort',
  addressLine: '9800 E Talking Stick Way',
  cityState: 'Scottsdale, AZ',
  /** The announcement bar retires itself the day after the show closes. */
  endsAt: new Date('2026-09-17T00:00:00-07:00'),
} as const;

/** True while the launch event is still upcoming or running. */
export const isMarketingEventCurrent = (now: Date = new Date()): boolean =>
  now.getTime() < marketingEvent.endsAt.getTime();

/**
 * Public booking links.
 *
 * The Google appointment scheduler is the real way to get time with the team;
 * keep it here so every "book" affordance points at one place.
 */
export const marketingLinks = {
  scheduler: 'https://calendar.app.google/VD8fxSHhyEHpsgAL6',
} as const;
